<template>
  <div class="s-component" :style="{height: mainHeight, 'background-image': `url(${bg.src})`}">
    <div class="s-part-1" :style="{top: `${part1Top}`}">
      <div class="spend-money" :style="{color:textColorActive, top: part1Obj[0].tipsPositionTop}">您的累计消费点券：{{ limitMoney }}</div>
      <div class="s-part-1-gift">
        <div class="consumption-box" :style="{width: part1Obj[0].bgWidth, height: part1Obj[0].bgHeight}">
          <div class="consumption-item" v-for="item in part1List" :key="item.id">
            <div class="consumption-price" :style="{color: part1Obj[0].textColor, fontSize: part1Obj[0].textFont}">累计消费
              <span
                :style="{color: part1Obj[0].priceColor}">{{ item.condition_ret && item.condition_ret.expect_val }}点券</span>
            </div>
            <img class="consumption-icon" :src="item.icon"
                 :style="{width: part1Obj[0].imgWidth, height: part1Obj[0].imgHeight}" alt="">
            <div class="consumption-btn" @click="receiveAward(item)">
              <div class="consumption-btn-icon" :class="item.status === 2 ? 'hv-highlight' : ''"
                   :style="{'background-image': `url(${getStatusText(item, 'bg')})`,width: part1Btn[0].btnWidth, height: part1Btn[0].btnHeight, color: miniBtnColor, fontSize: part1Obj[0].btnTextFont}">
                {{ getStatusText(item) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="s-part-2" :style="{top: `${part2Top}`}">
      <div class="s-part-2-gift">
        <div class="buy-box" :style="{width: part2Obj[0].bgWidth, height: part2Obj[0].bgHeight}">
          <div :style="{color: textColorLevel3}" style="margin-bottom: 20px;">活动期间内，以下特惠礼包单用户限购一次</div>
          <div class="buy-list">
            <div class="buy-item" v-for="item in part2List" :key="item.id">
              <img :src="item.icon" :style="{width: part2Obj[0].itemWidth, height: part2Obj[0].itemHeight}" alt="">
              <div class="buy-item-info">
                <div style="margin: 0 auto;font-size: 27px;width: 100%;text-align: center;">{{ item.name }}</div>
                <div style="font-size: 28px;color: #FFFFFF;text-decoration: line-through;font-weight: bold;">
                  原价：{{ item.desc }}
                </div>
                <div style="font-size: 34px;font-weight: bold;" :style="{color:textColorActive}">限时：{{ item.price }}</div>
                <div class="buy-item-btn">
                  <div class="buy-btn-icon hv-highlight" @click="buyGift(item)"
                       :style="{'background-image': `url(${part2Btn[0].btnSrc})`,width: part2Btn[0].btnWidth, height: part2Btn[0].btnHeight, color: miniBtnColor, fontSize: part2Obj[0].btnTextFont}">
                    {{ item.price }}点券
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="buy-lottery-tickets">
            <img :src="part2Obj[0].lotteryTitle"
                 :style="{width: part2Obj[0].lotteryTitleWidth, height: part2Obj[0].lotteryTitleHeight}" alt="">
            <div class="buy-lottery-btns">
              <div class="buy-tickets-icon hv-highlight" @click="buyGift(item)" v-for="item in part2List2"
                   :key="item.id"
                   :style="{'background-image': `url(${part2Btn[0].btnSrc})`,width: part2Btn[0].bigBtnWidth, height: part2Btn[0].bigBtnHeight, color: miniBtnColor, fontSize: part2Obj[0].btnTextFont}">
                {{ item.price }}点券购买{{ item.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="s-part-3" :style="{top: `${part3Top}`}">
      <div class="s-part-3-box" :style="{width: part3Obj[0].bgWidth}">
        <div :style="{color: textColorLevel3}" class="part3-title">
          <div>您当前拥有抽奖券： <span>{{ lotteryTickets }}</span></div>
          <div class="prop-backpack" @click="showPackage">道具背包</div>
        </div>
        <div class="part3-content">
          <div class="part3-content-bg"
               :style="{padding: part3Obj[0].padding,width: part3Obj[0].bgWidth, height: part3Obj[0].bgHeight, 'background-image': `url(${part3Obj[0].bgSrc})`}">
            <div class="part3-main" :style="{'grid-template-columns': `repeat(auto-fill, ${part3Obj[0].itemWidth})`}">
              <div class="part3-lottery-item" v-for="item in lotteryList" :key="item.id">
                <img :src="item.icon" alt="" :style="{width: part3Obj[0].itemWidth, height: part3Obj[0].itemHeight}">
              </div>
            </div>
          </div>
        </div>
        <div class="part3-btns">
          <div class="part3-btn hv-highlight"
               @click="lotteryFunc(1)"
               :style="{'background-image': `url(${receiveBtn0.src})`,width: part3Btn[0].btnWidth, height: part3Btn[0].btnHeight, color: miniBtnColor, fontSize: part3Obj[0].btnTextFont}">
            点击抽1次
          </div>
          <div class="part3-btn hv-highlight"
               @click="lotteryFunc(10)"
               :style="{'background-image': `url(${receiveBtn0.src})`,width: part3Btn[0].btnWidth, height: part3Btn[0].btnHeight, color: miniBtnColor, fontSize: part3Obj[0].btnTextFont}">
            点击抽10次
          </div>
        </div>
      </div>
    </div>
    <div class="s-part-4" :style="{top: `${part4Top}`}">
      <div class="s-part-4-box" :style="{width: part4Obj[0].bgWidth}">
        <div :style="{color: textColorLevel3}" class="part4-title">
          <div>活动积分： <span>{{ pointsNumber }}</span></div>
        </div>
        <div class="part4-content">
          <div class="part4-content-bg"
               :style="{padding: part4Obj[0].padding,width: part4Obj[0].bgWidth, height: part4Obj[0].bgHeight, 'background-image': `url(${part4Obj[0].bgSrc})`}">
            <div class="part4-main" :style="{'grid-template-columns': `repeat(auto-fill, ${part4Obj[0].itemWidth})`}">
              <div class="part4-lottery-item" v-for="item in pointList" :key="item.id">
                <div class="part4-lottery-item-box" style="position: relative"
                     :style="{width: part4Obj[0].itemWidth, height: part4Obj[0].itemHeight}">
                  <img :src="item.icon" alt="" style="width: 100%; height: 100%">
                  <div class="part4-lottery-item-tips"
                       :style="{fontSize: part4Obj[0].tipFont, color: part4Obj[0].tipColor}">积分：{{ item.price }}
                  </div>
                </div>
                <div class="part4-btn hv-highlight"
                     @click="exchangeFunc(item)"
                     :style="{'background-image': `url(${receiveBtn0.src})`,width: part4Btn[0].btnWidth, height: part4Btn[0].btnHeight, color: miniBtnColor, fontSize: part4Obj[0].btnTextFont}">
                  点击兑换
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--        <div class="part3-btns">-->
        <!--          <div class="part3-btn hv-highlight" :style="{'background-image': `url(${receiveBtn0.src})`,width: part3Btn[0].btnWidth, height: part3Btn[0].btnHeight, color: miniBtnColor, fontSize: part4Obj[0].btnTextFont}">点击抽10次</div>-->
        <!--        </div>-->
      </div>
    </div>
    <ModalReceive ref="ModalReceive"/>
    <SCommercialPackage ref="SCommercialPackage"/>
    <ModalReceiveLog ref="ModalReceiveLog"/>
    <slot></slot>
  </div>
</template>

<script>
import ModalReceive from '../_components/ModalReceive.vue'
import SCommercialPackage from './_components/SCommercialPackage.vue'
import ModalReceiveLog from '../_components/ModalReceiveLog.vue'

export default {
  name: 'SCommercialLottery',
  components: {
    ModalReceiveLog,
    ModalReceive,
    SCommercialPackage
  },
  props: {
    // 一键领取活动
    part1Top: {
      type: String,
      required: true
    },
    part1Obj: {
      type: Array,
      required: true,
      default: () => []
    },
    part1Btn: {
      type: Array,
      required: true,
      default: () => []
    },
    // 特惠礼包，限时购买
    part2Top: {
      type: String,
      required: true
    },
    part2Obj: {
      type: Array,
      required: true,
      default: () => []
    },
    part2Btn: {
      type: Array,
      required: true,
      default: () => []
    },
    // 登录领活动
    part3Top: {
      type: String,
      required: true
    },
    part3Obj: {
      type: Array,
      required: true,
      default: () => []
    },
    part3Btn: {
      type: Array,
      required: true,
      default: () => []
    },
    // 免费抽活动
    part4Top: {
      type: String,
      required: true
    },
    part4Obj: {
      type: Array,
      required: true,
      default: () => []
    },
    part4Btn: {
      type: Array,
      required: true,
      default: () => []
    },
    packageInfo: {
      type: Array,
      required: true,
      default: () => []
    },

    bg: {
      type: Object,
      required: true
    },
    mainHeight: {
      type: String,
      required: true
    },
    // ===== 任务 ID 配置 =====
    // 一键领
    activityId1: {
      type: String,
      default: ''
    },
    // 战斗领
    activityId2: {
      type: String,
      default: ''
    },
    // 额外福利
    activityId3: {
      type: String,
      default: ''
    },
    // 免费抽
    activityId4: {
      type: String,
      default: ''
    },
    // ===== text color =====
    textColorLevel1: {
      type: String,
      default: '#333'
    },
    textColorLevel2: {
      type: String,
      default: '#666'
    },
    textColorLevel3: {
      type: String,
      default: '#999'
    },
    textColorActive: {
      type: String,
      default: '#FFCC00'
    },
    miniBtnColor: {
      type: String,
      default: '#608351'
    },

    // ===== 抽奖Btn =====
    // drawActiveItem: {
    //   type: String,
    //   default: ''
    // },
    // ===== 登录领取Btn =====
    receiveBtn0: {
      type: Object,
      required: true
    },
    receiveBtn1: {
      type: Object,
      required: true
    },
    receiveBtn2: {
      type: Object,
      required: true
    },
    receiveBtn3: {
      type: Object,
      required: true
    },
    receiveBtn4: {
      type: Object,
      required: true
    },

    // ===== modal =====
    modalBg: {
      type: Object,
      default: () => {
      }
    },
    modalCloseIcon: {
      type: Object,
      default: () => {
      }
    },
    modalTitleStyle: {
      type: String,
      default: '{}'
    },
    modalTextStyle: {
      type: String,
      default: '{}'
    },
    modalConfirmBtnStyle: {
      type: String,
      default: '{}'
    },
    modalCancelBtnStyle: {
      type: String,
      default: '{}'
    }

  },
  data () {
    return {
      wdFrom: '',
      from: '',
      limitMoney: 0, // 累计消费数量
      pointsNumber: 0, // 积分数量
      lotteryTickets: 0, // 抽奖券数量
      part1List: [
        {
          condition_ret: {
            actual_val: 0
          }
        }
      ],
      part2List: [],
      part2List2: [],
      pointList: [],
      lotteryList: [],

      part3Info: [],

      point: 0,
      lotteryAct: {
        award: {
          groups: []
        }
      }
    }
  },
  provide () {
    return {
      $MainWrap: this
    }
  },

  inject: {
    eventBus: {
      default: null
    }
  },
  computed: {
    requestAPI () {
      // eslint-disable-next-line no-undef
      return this.request ? this.request : $request
    }
  },
  mounted () {
    const { from, wdFrom } = this.$route.query
    this.from = from
    this.wdFrom = wdFrom
    if (this.eventBus) {
      // 登录成功操作添加
      this.eventBus.on('loginSuccess', this.init)
      // 登出操作添加
      this.eventBus.on('signOut', this.init)
    }
    this.init(1)

    // this.openLog(4)
    console.log(this.bg)
  },
  methods: {
    showPackage () {
      if (!window.$checkLogin()) return
      this.$refs.SCommercialPackage.open({
        title: '道具背包'
      })
    },
    lotteryFunc (count) {
      if (!window.$checkLogin()) return
      this.$alert(`是否花费抽奖券进行抽奖`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showCancelButton: true,
        callback: action => {
          console.log(action)
          if (action === 'confirm') {
            this.requestAPI({
              url: '/v1/business/lottery',
              method: 'get',
              params: { a_id: this.activityId3, count }
            }).then((res) => {
              console.log(res, '--multiLottery---')
              const arr = []
              res.forEach((item) => {
                arr.push(item.name + '*' + item.group_count)
              })
              this.$alert(`恭喜您获得${arr.join('、')}`, '提示', {
                confirmButtonText: '确定'
              })
              this.getMoneyFunc([this.activityId3])
            }).catch((err) => {
              this.$message.error(err.msg || '系统错误')
            })
          }
        }
      })
    },
    exchangeFunc (item) {
      if (!window.$checkLogin()) return
      this.$alert(`是否消耗积分${item.price} 兑换 ${item.name}`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showCancelButton: true,
        callback: action => {
          console.log(action)
          if (action === 'confirm') {
            this.requestAPI({
              url: '/v1/uni/receive',
              method: 'get',
              params: {
                a_id: this.activityId4,
                g_id: item.id,
                amount: 1
              }
            }).then((data) => {
              console.log(item.id)
              if (data.success) {
                this.$alert(`恭喜您获得${data.gift.name}`, '提示', {
                  confirmButtonText: '确定'
                })
                this.getMoneyFunc([this.activityId4])
              } else {
                this.$message.error(data.msg || '系统错误')
              }
            }).catch((err) => {
              console.error(err)
              this.$message.error(err.msg || '系统错误')
            })
          }
        }
      })
    },
    // 活动1领取
    receiveAward (item) {
      console.log('---receiveAward---', item)
      // 判断登录
      if (!window.$checkLogin()) return

      if (item.status !== 2) return
      const params = {
        a_id: this.activityId1,
        g_id: item.id
      }
      return this.requestAPI({
        url: '/v1/uni/receive',
        method: 'get',
        params
      }).then((data) => {
        console.log(item.id)
        if (data.success) {
          this.$alert(`恭喜您获得${data.gift.name}`, '提示', {
            confirmButtonText: '确定'
          })
          this.getGift1Info()
        } else {
          this.$message.error(data.msg || '系统错误')
        }
      }).catch((err) => {
        console.error(err)
        this.$message.error(err.msg || '系统错误')
      })
    },
    getLimitMoney () {
      this.requestAPI({
        url: '/v1/uni/act-consume',
        method: 'get',
        params: {
          a_id: this.activityId2
        }
      }).then((res) => {
        this.limitMoney = res[this.activityId2] || 0
      }).catch((err) => {
        console.error(err)
        this.$message.error(err.msg || '系统错误')
      })
    },
    buyGift (item) {
      console.log('---buyGift---', item)
      // 判断登录
      if (!window.$checkLogin()) return
      this.$alert(`是否消耗点券${item.price} 购买 ${item.name}`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showCancelButton: true,
        callback: action => {
          console.log(action)
          if (action === 'confirm') {
            const params = {
              a_id: this.activityId2,
              g_id: item.id
            }
            this.requestAPI({
              url: '/v1/uni/receive',
              method: 'get',
              params
            }).then((res) => {
              console.log(res, '购买的返回信息')
              this.$alert(`恭喜您获得${res.gift.name}`, '提示', {
                confirmButtonText: '确定'
              })
              this.getGift1Info()
              this.getLimitMoney()
              this.getMoneyFunc([this.activityId3])
            }).catch((err) => {
              console.error(err)
              this.$message.error(err.msg || '系统错误')
            })
          }
        }
      })
    },
    getMoneyFunc (idStr) {
      this.requestAPI({
        url: '/v1/uni/act-integral',
        method: 'get',
        params: { a_id: idStr.join(',') }
      }).then(res => {
        console.log('----获取多个活动的积分信息 ----', res)
        this.pointsNumber = res[this.activityId4] !== undefined ? res[this.activityId4] : this.pointsNumber
        this.lotteryTickets = res[this.activityId3] !== undefined ? res[this.activityId3] : this.lotteryTickets
      }).catch((err) => {
        console.error(err)
        this.$message.error(err.msg || '系统错误')
      })
    },
    getStatusText (item, type) {
      const map = {
        0: '未开始',
        1: '未完成',
        2: '领取',
        3: '已领取',
        4: '已过期'
      }
      const map1 = {
        0: this.receiveBtn0.src,
        1: this.receiveBtn0.src,
        2: this.receiveBtn0.src,
        3: this.receiveBtn0.src,
        4: this.receiveBtn0.src
      }
      if (type === 'bg') {
        return map1[item.status]
      } else {
        return map[item.status]
      }
    },
    init (type) {
      this.getGift1Info()
      this.getGift2Info()
      this.getGift3Info()
      this.getGift4Info()
      if (localStorage.getItem('activeToken')) {
        this.getMoneyFunc([this.activityId3, this.activityId4])
        this.getLimitMoney()
      }
    },
    // 累计消费活动
    getGift1Info () {
      this.requestAPI({
        url: '/v1/uni/info',
        method: 'get',
        params: { a_id: this.activityId1 }
      }).then(res => {
        console.log('----点券累消领取----', res)
        this.part1List = res.groups || []
      }).catch((err) => {
        console.error(err)
        this.$message.error(err.msg || '系统错误')
      })
    },
    // 购买抽奖券
    getGift2Info () {
      this.requestAPI({
        url: '/v1/uni/info',
        method: 'get',
        params: { a_id: this.activityId2 }
      }).then(res => {
        console.log('----购买抽奖券----', res)
        this.part2List = (res.groups && res.groups.slice(0, 3)) || []
        this.part2List2 = (res.groups && res.groups.slice(3)) || []
      }).catch((err) => {
        console.error(err)
        this.$message.error(err.msg || '系统错误')
      })
    },
    // 奖池一览活动
    getGift3Info () {
      this.requestAPI({
        url: '/v1/uni/info',
        method: 'get',
        params: { a_id: this.activityId3 }
      }).then(res => {
        console.log('----奖池一览----', res)
        this.lotteryList = res.groups || []
      }).catch((err) => {
        console.error(err)
        this.$message.error(err.msg || '系统错误')
      })
    },
    // 积分兑换任务
    getGift4Info () {
      this.requestAPI({
        url: '/v1/uni/info',
        method: 'get',
        params: { a_id: this.activityId4 }
      }).then(res => {
        console.log('----积分兑换任务----', res)
        this.pointList = res.groups || []
      }).catch((err) => {
        console.error(err)
        this.$message.error(err.msg || '系统错误')
      })
    },
    /**
     * 一键领取活动奖励
     * @param item
     */

    /**
     * 战斗领活动奖励
     * @param item
     */
    receiveWeekAward (item) {
      // 判断登录
      if (!window.$checkLogin()) return
      if (item.status !== 2) return
      const params = {
        a_id: this.activityId2,
        g_id: item.id
      }
      return this.requestAPI({
        url: '/v1/back/week/receive',
        method: 'get',
        params
      }).then((data) => {
        console.log(item.id)
        if (data.success) {
          if (data.gift && data.gift.materials) {
            this.openReceiveModal(data.gift.materials)
          } else {
            this.openReceiveModal(item.materials)
          }
          this.getGift2Info()
        } else {
          this.$message.error(data.msg || '系统错误')
        }
      }).catch((err) => {
        console.error(err)
        this.$message.error(err.msg || '系统错误')
      })
    },
    /**
     * 额外活动奖励
     * @param item
     */
    receiveAllChannelExtraInfo (item) {
      // 判断登录
      if (!window.$checkLogin()) return
      if (item.status !== 2) return
      const params = {
        a_id: this.activityId3,
        g_id: item.id
      }
      return this.requestAPI({
        url: '/v1/back/login/receive',
        method: 'get',
        params
      }).then((data) => {
        console.log(data, '--data---')
        if (data.success) {
          if (data.gift && data.gift.materials) {
            this.openReceiveModal(data.gift.materials)
          } else {
            this.openReceiveModal(item.materials)
          }
          this.getGift3Info()
        } else {
          this.$message.error(data.msg || '系统错误')
        }
      }).catch((err) => {
        console.error(err)
        this.$message.error(err.msg || '系统错误')
      })
    },
    /**
     * 免费抽活动奖励
     * @param item
     */
    reciveLotteryInfo () {
      if (!window.$checkLogin()) return
      if (!this.lotteryAct.available) {
        this.$message.error('抽奖次数不足')
        // this.$message.warnning('抽奖次数不足')
        // this._handleTips({msg: '您当前暂未获得抽奖次数'})
        return
      }
      this.requestAPI({
        url: '/v1/back/lottery/receive',
        method: 'get',
        params: { a_id: this.activityId4 }
      }).then(data => {
        console.log(data, '---data---')
        if (data.id) {
          this.openReceiveModal([
            {
              name: data.name,
              icon: data.icon
            }
          ])
        }
        this.getGift4Info()
      }).catch((err) => {
        console.error(err)
        this.$message.error(err.msg || '系统错误')
      })
    },
    /**
     * 打开领取弹窗
     * @param awardsList 奖励列表 [{name: '', icon: ''}]
     * @param showAddress 是否显示地址
     */
    openReceiveModal (awardsList, showAddress = false) {
      this.$refs.ModalReceive.open(awardsList, showAddress)
    },
    /**
     * 打开记录弹窗
     * @param type 2: 抽奖记录 3: 领取记录 4: 兑换记录
     */
    openLog (type) {
      if (!window.$checkLogin()) return
      const titleMap = {
        // 1: '购买记录',
        // 2: '抽奖记录',
        4: '抽奖记录'
      }
      const title = titleMap[type]
      // console.log('---openLog---', type, title)
      this.$refs.ModalReceiveLog.open({
        title,
        activityId: this[`activityId${type}`],
        needAddress: type === 3
      })
    },
    /**
     * 打开积分记录弹窗
     */
    // openPointLog () {
    //   if (!window.$checkLogin()) return
    //   const options = {
    //     activityId: this.activityId4
    //   }
    //   this.$refs.ModalPointLog.open(options)
    // },
    openAddress () {
      this.$refs.ModalAddress.open(this.activityId3)
    }
  }
}
</script>
<style lang="scss" scoped>
.s-component {
  position: relative;
  background-color: rgba(0, 0, 0, .1);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  min-height: 5000px;
}
.mini-color-btn{
  text-decoration: underline;
  display: inline-block;
  width: 95px;
  height: 30px;
  border: 1PX solid;
  line-height: 28px;
  font-size: 16px;
  text-align: center;
  cursor: pointer;
}
.s-part-1, .s-part-2, .s-part-3, .s-part-4 {
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.s-part-1 {
  position: relative;

  .spend-money {
    position: absolute;
    font-family: Source Han Sans CN;
    font-weight: bold;
    font-size: 32px;
    color: #FFF000;
    line-height: 52px;
    left: 50%;
    transform: translateX(-50%);
  }
  .s-part-1-btn, .s-part-1-gift {
    display: flex;
    justify-content: center;
  }
  .consumption-box {
    margin: 0 auto;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .consumption-item {
      position: relative;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .consumption-icon {
        margin: 0 auto;
      }
      .consumption-btn {
        margin: 0 auto;
        .consumption-btn-icon {
          background-size: 100% 100%;
          background-repeat: no-repeat;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      .consumption-price {
        width: 100%;
        text-align: center;
        margin-bottom: 50px;
      }

    }
  }
  .s-part-1-btn {
    margin-top: 20px;
  }
}
.s-part-2 {
  .s-part-2-gift {
    display: flex;
    justify-content: center;
    margin: 0 auto;
  }
  .buy-box {
    font-size: 30px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  .buy-list{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .buy-lottery-tickets {
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    align-items: center;
    padding-top: 60px;
    .buy-lottery-btns {
      display: flex;
      width: 80%;
      justify-content: space-between;
      margin-top: 30px;
    }
    .buy-tickets-icon {
      background-size: 100% 100%;
      background-repeat: no-repeat;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 6px auto;
    }
  }
  .buy-item {
    position: relative;
    .buy-item-info {
      position: absolute;
      bottom: 30px;
      height: 200px;
      width: 84%;
      left: 50%;
      transform: translateX(-50%);
      color: #fff;
    }
    .buy-btn-icon {
      background-size: 100% 100%;
      background-repeat: no-repeat;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 6px auto;
    }
  }
}
.s-part-3 {
  .part3-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    font-size: 24px;
  }
  .part3-btns {
    margin-top: 40px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .part3-btn {
      background-size: 100% 100%;
      background-repeat: no-repeat;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .part3-content {
    .part3-content-bg {
      display: flex;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      justify-content: center;
      align-items: center;
    }
    .part3-main {
      flex-wrap: wrap;
      display: grid;
      justify-content: space-between;
      grid-gap: 10px;
      height: 100%;
      width:100%;
      overflow-y: auto;
    }
    // 修改滚动条样式
    .part3-main ::-webkit-scrollbar {
      width: 0;
      height: 0;
      background-color: rgba(255,255,255,0.1);
    }
    .part3-lottery-item {
      padding: 10px 0;
    }
  }
}
.s-part-4 {
  .part4-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    font-size: 24px;
  }
  .part4-btn {
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .part4-content {
    .part4-content-bg {
      display: flex;
      justify-content: center;
      align-items: center;
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
    .part4-main {
      flex-wrap: wrap;
      display: grid;
      justify-content: space-between;
      grid-gap: 10px;
      height: 100%;
      width:100%;
      overflow-y: auto;
    }
    // 修改滚动条样式
    .part4-main ::-webkit-scrollbar {
      width: 0;
      height: 0;
      background-color: rgba(255,255,255,0.1);
    }
    .part4-lottery-item {
      padding: 10px 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-content: center;
    }
    .part4-lottery-item-box {
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: relative;
      align-items: center;
      margin-bottom: 20px;
      .part4-lottery-item-tips {
        position: absolute;
        left: 10px;
        bottom: 10px;
      }
    }
  }
}
</style>
